module.exports = __webpack_public_path__ + "assets/img/up_d2.985f6b96.png";